import Web3 from 'web3';
import { abiUSD } from './ABI/USD.js';
import {
    detectCurrentProvider,
    AdminPaymentAddress,
    TokenPayAmount
} from './ContractDependency.js';

const chainAddresses = require('./ChainAddresses.json');

var abiUSDToken = abiUSD;

export const getCurrentChainId = async () => {
    // console.log('getCurrentChainId');
    try {
        const provider = detectCurrentProvider();
        if (!provider) {
            throw new Error(
                'No Ethereum provider found. Please install MetaMask or Trust Wallet.'
            );
        }
        const web3 = new Web3(provider);
        const CurrentChainId = Number(await web3.eth.net.getId());
        // console.log('CurrentChainId', CurrentChainId);
        return CurrentChainId;
    } catch (error) {
        // Error getting chain ID
    }
};
// getCurrentChainId()

export const getCurrentChainIdAllDetails = async () => {
    try {
        let chainId = await getCurrentChainId();
        const chain = chainAddresses.find(chain =>
            chain.hasOwnProperty(chainId)
        );
        if (chain) {
            const allTokens = chain[chainId].map(token => ({
                stableCoinAddress: token.StableCoinAddress,
                stableCoinName: token.StableCoinName,
                name: token.name,
                routerAddress: token.Routeraddress,
                dexLink: token.Dexlink,
                explorerLink: token.explorerlink
            }));
            // console.log('getCurrentChainIdAllDetails:', allTokens);
            return allTokens;
        } else {
            return [];
        }
    } catch (error) {
        return [];
    }
};
// getCurrentChainIdAllDetails();

export const getCurrentChainIdStableCoinAddress = async chainId => {
    // console.log('getCurrentChainIdStableCoinAddress');
    const chainDetails = chainAddresses.find(chain =>
        chain.hasOwnProperty(chainId)
    );
    // console.log('chainDetails', chainDetails);
    if (chainDetails) {
        const stableCoinAddress = chainDetails[chainId].find(
            token => token.StableCoinAddress !== undefined
        );
        if (stableCoinAddress) {
            return stableCoinAddress.StableCoinAddress;
        } else {
            return null;
        }
    } else {
        return null;
    }
};

export const getTokenBalance = async tokenContractAddress => {
    // console.log('getTokenBalance');
    try {
        const provider = detectCurrentProvider();
        if (!provider) {
            throw new Error(
                'No Ethereum provider found. Please install MetaMask or Trust Wallet.'
            );
        }
        const web3 = new Web3(provider);
        const accounts = await provider.request({
            method: 'eth_accounts'
        });
        const account = accounts[0];
        const contracts = new web3.eth.Contract(
            abiUSDToken,
            tokenContractAddress
        );
        // console.log('contracts_methods', contracts.methods);
        // console.log('account', account);
        const response = await contracts.methods.balanceOf(account).call();
        // const balance = Number(web3.utils.fromWei(response, 'ether'));
        const balance = Number(response) / 10 ** 6;
        // console.log(`TokenBalance of ${tokenContractAddress}`, balance);
        return balance;
    } catch (error) {
        // Error getting token balance
    }
};

export const getTokenSymbol = async tokenContractAddress => {
    try {
        const provider = detectCurrentProvider();
        if (!provider) {
            throw new Error(
                'No Ethereum provider found. Please install MetaMask or Trust Wallet.'
            );
        }
        const web3 = new Web3(provider);
        const contract = new web3.eth.Contract(
            abiUSDToken,
            tokenContractAddress
        );
        const tokenSymbol = await contract.methods.symbol().call();
        return tokenSymbol;
    } catch (error) {
        // Error getting token symbol
    }
};

export const getCurrentTxExplorer = async () => {
    const currentChainId = await getCurrentChainId();
    // console.log('getCurrentTxExplorerCurrentChainId', currentChainId);
    const currentChainIdInHex = Web3.utils.toHex(currentChainId);
    const networkExplorers = [
        {
            key: 1,
            networkExplorer: 'https://etherscan.io/tx/',
            chainId: '0x1'
        },
        {
            key: 2,
            networkExplorer: 'https://bscscan.com/tx/',
            chainId: '0x56'
        },
        {
            key: 3,
            networkExplorer: 'https://polygonscan.com/tx/',
            chainId: '0x137'
        },
        {
            key: 4,
            networkExplorer: 'https://snowscan.xyz/tx/',
            chainId: '0x43114'
        },
        {
            key: 5,
            networkExplorer: 'https://arbiscan.io/tx/',
            chainId: '0x42161'
        },
        {
            key: 6,
            networkExplorer: 'https://optimistic.etherscan.io/tx/',
            chainId: '0x10'
        },
        {
            key: 7,
            networkExplorer: 'https://basescan.org/tx/',
            chainId: '0x8453'
        },
        {
            key: 8,
            networkExplorer: 'https://explorer.celo.org/mainnet/tx/',
            chainId: '0x42220'
        },

        {
            key: 9,
            networkExplorer: 'https://sepolia.etherscan.io/tx/',
            chainId: '0xaa36a7'
        },
        {
            key: 10,
            networkExplorer: 'https://testnet.bscscan.com/tx/',
            chainId: '0x61'
        },
        {
            key: 11,
            networkExplorer: 'https://amoy.polygonscan.com/tx/',
            chainId: '0x13881'
        },
        {
            key: 12,
            networkExplorer: 'https://testnet.snowtrace.io/tx/',
            chainId: '0xa869'
        },
        {
            key: 13,
            networkExplorer: 'https://goerli.basescan.org/tx/',
            chainId: '0x2105'
        },

        {
            key: 14,
            networkExplorer: 'https://goerli-optimism.etherscan.io/tx/',
            chainId: '0xa'
        },
        {
            key: 15,
            networkExplorer: 'https://alfajores.celoscan.io/tx/',
            chainId: '0xa4ec'
        }
    ];
    const currentNetworkExplorer = networkExplorers.find(
        explorer =>
            explorer.chainId.toLowerCase() === currentChainIdInHex.toLowerCase()
    );
    // console.log(
    //     'currentNetworkTXNExplorer',
    //     currentNetworkExplorer.networkExplorer
    // );
    return currentNetworkExplorer
        ? currentNetworkExplorer.networkExplorer
        : null;
};
// getCurrentTxExplorer()

export const getImportedAddressExplorer = async () => {
    const currentChainId = await getCurrentChainId();
    // console.log('getCurrentTxExplorerCurrentChainId', currentChainId);
    const currentChainIdInHex = Web3.utils.toHex(currentChainId);
    const networkExplorers = [
        {
            key: 1,
            networkExplorer: 'https://etherscan.io/address/',
            chainId: '0x1'
        },
        {
            key: 2,
            networkExplorer: 'https://bscscan.com/address/',
            chainId: '0x56'
        },
        {
            key: 3,
            networkExplorer: 'https://polygonscan.com/address/',
            chainId: '0x137'
        },
        {
            key: 4,
            networkExplorer: 'https://snowscan.xyz/address/',
            chainId: '0x43114'
        },
        {
            key: 5,
            networkExplorer: 'https://arbiscan.io/address/',
            chainId: '0x42161'
        },
        {
            key: 6,
            networkExplorer: 'https://optimistic.etherscan.io/address/',
            chainId: '0x10'
        },
        {
            key: 7,
            networkExplorer: 'https://basescan.org/address/',
            chainId: '0x8453'
        },
        {
            key: 8,
            networkExplorer: 'https://explorer.celo.org/mainnet/address/',
            chainId: '0x42220'
        },

        {
            key: 9,
            networkExplorer: 'https://sepolia.etherscan.io/address/',
            chainId: '0xaa36a7'
        },
        {
            key: 10,
            networkExplorer: 'https://testnet.bscscan.com/address/',
            chainId: '0x61'
        },
        {
            key: 11,
            networkExplorer: 'https://amoy.polygonscan.com/address/',
            chainId: '0x13881'
        },
        {
            key: 12,
            networkExplorer: 'https://testnet.snowtrace.io/address/',
            chainId: '0xa869'
        },
        {
            key: 13,
            networkExplorer: 'https://goerli.basescan.org/address/',
            chainId: '0x2105'
        },

        {
            key: 14,
            networkExplorer: 'https://goerli-optimism.etherscan.io/address/',
            chainId: '0xa'
        },
        {
            key: 15,
            networkExplorer: 'https://alfajores.celoscan.io/address/',
            chainId: '0xa4ec'
        }
    ];
    const currentNetworkExplorer = networkExplorers.find(
        explorer =>
            explorer.chainId.toLowerCase() === currentChainIdInHex.toLowerCase()
    );
    // console.log(
    //     'currentNetworkADDRExplorer',
    //     currentNetworkExplorer.networkExplorer
    // );
    return currentNetworkExplorer
        ? currentNetworkExplorer.networkExplorer
        : null;
};
// getImportedAddressExplorer()

export const transferPayment = async () => {
    try {
        const provider = detectCurrentProvider();
        if (!provider) {
            console.error('Noproviderdetected');
        }
        // console.log('Providerdetected:', provider);
        const web3 = new Web3(provider);
        await provider.request({
            method: 'eth_requestAccounts'
        });
        const accounts = await provider.request({
            method: 'eth_accounts'
        });
        const account = accounts[0];
        // console.log('Accountfound:', account);
        const currentChainId = await getCurrentChainId();
        if (!currentChainId) {
            console.error('UnableToRetrieveCurrentChainID');
        }
        // console.log('CurrentChainID:', currentChainId);
        const paymentTokenAddress = await getCurrentChainIdStableCoinAddress(
            currentChainId
        );
        if (!paymentTokenAddress) {
            console.error('UnableToRetrieveStablecoinAddress_chainID');
        }
        // console.log('PaymentTokenAddress:', paymentTokenAddress);
        const contracts = new web3.eth.Contract(
            abiUSDToken,
            paymentTokenAddress
        );
        // console.log('contracts', contracts);
        const tokenPayDecimals = await contracts.methods.decimals().call();
        // console.log('tokenPayDecimals', tokenPayDecimals);
        const tokenPayAmount = (
            Number(TokenPayAmount) *
            10 ** Number(tokenPayDecimals)
        ).toString();
        // console.log('tokenPayAmount', tokenPayAmount);
        const resTransferPayment = await contracts.methods
            .transfer(AdminPaymentAddress, tokenPayAmount)
            .send({
                from: account
            });
        // console.log('TransferSuccessful:', resTransferPayment);
        const txExplorer = await getCurrentTxExplorer();
        const txHashResponse = {
            txHash: txExplorer + resTransferPayment.transactionHash,
            status: resTransferPayment.status
        };
        // console.log('txHashResponse', txHashResponse);
        return txHashResponse;
    } catch (error) {
        // Error in transfer payment
    }
};
// transferPayment()

export const refundTransferPayment = async (refundAddress, amountToPay) => {
    try {
        const provider = detectCurrentProvider();
        if (!provider) {
            return;
        }
        const web3 = new Web3(provider);
        await provider.request({
            method: 'eth_requestAccounts'
        });
        const accounts = await provider.request({
            method: 'eth_accounts'
        });
        const account = accounts[0];
        const currentChainId = await getCurrentChainId();
        const paymentTokenAddress = await getCurrentChainIdStableCoinAddress(
            currentChainId
        );
        if (!paymentTokenAddress) {
            return;
        }
        const contracts = new web3.eth.Contract(
            abiUSDToken,
            paymentTokenAddress
        );
        // console.log('contracts', contracts);
        const tokenPayDecimals = await contracts.methods.decimals().call();
        const tokenPayAmount = (
            Number(amountToPay) *
            10 ** Number(tokenPayDecimals)
        ).toString();
        const resTransferPayment = await contracts.methods
            .transfer(refundAddress, tokenPayAmount)
            .send({
                from: account
            });
        // console.log('RefundTransferSuccessful:', resTransferPayment);
        const txExplorer = await getCurrentTxExplorer();
        const txHashResponse = {
            txHash: resTransferPayment?.transactionHash,
            explorerTxHash: txExplorer + resTransferPayment?.transactionHash,
            status: resTransferPayment?.status,
            sender: resTransferPayment?.from,
            receiver: resTransferPayment?.to
        };
        // console.log('txHashRefundResponse', txHashResponse);
        return txHashResponse;
    } catch (error) {
        // Error in refund transfer payment
    }
};
// refundTransferPayment('0x09166e7791F8Cd4b4bd3F396a9C1c240466EbbD0', 1);
